import React, { useState } from "react";

const Toggle = ({
  defaultChecked = false,
  checked,
  onChange,
  disabled = false,
}) => {
  const [internalState, setInternalState] = useState(defaultChecked);
  const isControlled = checked !== undefined;
  const isOn = isControlled ? checked : internalState;

  const handleToggle = () => {
    if (disabled) return;
    if (!isControlled) {
      const newState = !internalState;
      setInternalState(newState);
      onChange && onChange(newState);
    } else {
      onChange && onChange(!checked);
    }
  };

  return (
    <>
      {!disabled && (
        <div
          className={`toggle ${isOn ? "toggle--on" : "toggle--off"}${disabled ? " toggle--disabled" : ""}`}
          onClick={handleToggle}
        >
          <div className="toggle__circle" />
        </div>
      )}
    </>
  );
};

export default Toggle;
